import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  placeholder: {
    marginTop: Spacing.XS,
    marginBottom: Spacing.S,
  },
  highlight: {
    color: Color.modifiedGrey,
  },
  type: {
    textAlign: 'center',
  },
})

interface Props extends ViewProps {}

const UploadPlaceholder = (props: Props) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text style={styles.placeholder}>
        <Trans>
          Drag and drop or{' '}
          <Text level={5} style={styles.highlight}>
            Choose file
          </Text>{' '}
          to upload
        </Trans>
      </Text>
      <Text style={styles.type} level={7}>
        <Trans>JPG, PNG or BMP</Trans>
      </Text>
    </View>
  )
}

export default UploadPlaceholder
